import { createFormAction } from 'redux-form-saga'
export const DEPARTMENT_FORM_KEY = 'DEPARTMENT_IN_FORM'
export const DEPARTMENTFormAction = createFormAction(DEPARTMENT_FORM_KEY)